import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export default function SubscriptionLockNotice() {
  return (
    <div className="mx-auto w-[90%] max-w-7xl pt-4">
      <div className="flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 shadow-[0_10px_24px_rgba(180,83,9,0.08)]">
        <ExclamationTriangleIcon className="mt-0.5 h-5 w-5 flex-shrink-0" />
        <div>
          <div className="font-semibold">Subscription access is limited</div>
          <div className="mt-1">
            Your subscription has ended. Billing remains available so you can update payment details or resubscribe.
          </div>
        </div>
      </div>
    </div>
  );
}
